var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 72 72",
    style: {
      fill: "#00889C"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 36 12 C 22.75 12 12 22.75 12 36 C 12 49.25 22.75 60 36 60 C 49.25 60 60 49.25 60 36 C 60 33.41 59.590313 30.919844 58.820312 28.589844 L 51.529297 39.859375 C 51.506297 39.952375 51.482031 40.045672 51.457031 40.138672 C 49.640031 46.967672 43.409 52 36 52 C 27.16 52 20 44.84 20 36 C 20 27.16 27.16 20 36 20 C 38.54 20 40.940312 20.590625 43.070312 21.640625 L 47.429688 14.900391 C 44.029687 13.050391 40.14 12 36 12 z M 53.121094 17.126953 C 51.676768 17.155645 50.272109 17.877266 49.427734 19.181641 L 39.154297 35.058594 L 33.966797 29.111328 C 32.332797 27.237328 29.488187 27.045687 27.617188 28.679688 C 25.744187 30.313688 25.551547 33.155344 27.185547 35.027344 L 36.298828 45.472656 C 37.156828 46.455656 38.394453 47.015625 39.689453 47.015625 C 39.796453 47.015625 39.902766 47.010906 40.009766 47.003906 C 41.418766 46.902906 42.698797 46.147937 43.466797 44.960938 L 56.984375 24.070312 C 58.334375 21.984313 57.737391 19.198656 55.650391 17.847656 C 54.868891 17.341781 53.987689 17.109738 53.121094 17.126953 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.068e4a938437040cf290acd7ac3d0de0.svg";
export { ForwardRef as ReactComponent };